import React from "react";
import clsx from "clsx";
import Spinner from "./spinner";

interface ButtonProps {
  variant: "primary" | "success" | "search" | "greyed" | "grouped" | "close" | "wxpay" | "green";
  text?: string;
  node?: any;
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  spinnerSize?: number;
  onClick?: (_: any) => void;
}

const Button: React.FC<ButtonProps> = ({ variant, text, node, type, className, disabled, loading, spinnerSize, onClick }) => {
  if (!text) text = "";
  let jsx;
  if (loading)
    jsx = (
      <div className="flex">
        <Spinner size={spinnerSize || 20} />
      </div>
    );
  else if (text) jsx = <span>{text}</span>;
  else if (node) jsx = node;
  return (
    <button
      className={clsx("d-btn", className && className, variant, disabled && "disabled", loading && "loading")}
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={`btn-${text.toLowerCase()}`}
    >
      {jsx}
    </button>
  );
};

export default Button;
